import script from "./IQAccountCreation.vue?vue&type=script&lang=ts&setup=true"
export * from "./IQAccountCreation.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__